<template>
  <div
    class="home-wrapper"
    :class="getEnv === 'prod' ? 'prod-color' : 'stage-color'"
  >
    <img alt="AARP logo" src="@/assets/aarp-logo.svg" />
    <div>
      <span class="admin-text q-mr-xs">
        {{ adminPortalText }}
      </span>
      <span v-if="getEnv === 'stage'">
        <strong> Stage </strong>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "HomeView",
  data() {
    return {
      account: null,
      adminPortalText: "Admin Portal",
      // auth: new URL(location.href).searchParams.get("auth"),
    };
  },
  computed: {
    ...mapGetters({
      getEnv: "selectEnv/getEnv",
    }),
  },
};
</script>

<style lang="scss" scoped>
.home-wrapper {
  position: fixed;
  top: 20;
  left: 0;
  width: 100% !important;
  height: 100%;
  padding: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.prod-color {
  background-image: linear-gradient(to top, rgba(255, 0, 0, 0), $primary);
}
.stage-color {
  background-image: linear-gradient(to top, rgba(255, 0, 0, 0), $secondary);
}
img {
  width: 100% !important;
}
.admin-text {
  font-size: 3em;
  color: $white;
}
</style>
